export var DEFAULT_ANIMATION_DURATION=500;